module.exports = __webpack_public_path__ + "static/img/icon-02.78ffb7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/value/icon-02.png
// module id = 6Ilc
// module chunks = 1